export class flowsheet {
  flowSheetDescription: string;
  flowSheetId: number;
  flowSheetName: string;
  lastUpdatedBy: string;
  lastUpdatedTimeStamp: string;
  refineryName: string;

  constructor() {
    this.flowSheetDescription = '';
    this.flowSheetId = 0;
    this.flowSheetName = '';
    this.lastUpdatedBy = '';
    this.refineryName = '';
    this.lastUpdatedTimeStamp = '';
    this.refineryName = ''
  }
}
